import search from "@assets/redesign/icons/searchButton.svg";
import useCustomSearch from "./CustomSearch.control";
import "./CustomSearch.scss";

export interface CustomSearchParams {
  isDisabled?: boolean;
  onChange: (search: string) => void;
}

function CustomSearch(params: CustomSearchParams): JSX.Element {

  const control = useCustomSearch(params);

  return (
    <div className={`customSearch__container ${control.hasErrors ? "error": ""} ${control.isDisabled ? "disabled" : ""}`}>
      <i 
        className={`customSearch__clear ${control.isEmpty() ? "hidden" : ""}`}
        onClick={control.clear}
      ></i>
      <input 
        autoFocus
        type="text" 
        value={control.search}
        onChange={control.updateSearch}
        onBlur={control.updateSearch}
        disabled={control.isDisabled}
      />
      <button 
        className="customSearch__search" 
        onClick={control.submit}
        disabled={control.isDisabled}
      >
        <img src={search} alt="" />
      </button>
    </div>
  );

}

export default CustomSearch;